import { oqulyqtarApi } from '../api';

const libraryApi = oqulyqtarApi.injectEndpoints({
    endpoints: (build) => ({
        getList: build.query({
            query: (filters) => ({
                url: `/library/list${filters && filters}`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => ['LibraryList'],
        }),
        getPublisherList: build.query({
            query: () => ({
                url: `/library/publisher-list`,
                method: 'GET'
            }),
            // Атамұра перешли на собственную платформу и не должны предлагаться в списке издательств
            transformResponse: (response) => ({
                ...response,
                publishers: response?.publishers?.filter(
                    (item) => item.name?.trim().toLowerCase() !== 'атамұра'
                )
            })
        }),
        getCheckSubscriptionAccess: build.query({
            query: (id) => ({
                url: `/library/check-subscription-access?book_id=${id}`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => [ 'LibraryCheckSubscriptionAccess'],
        }),
        getPackageList: build.query({
            query: (filters) => ({
                url: `/library/package-list${filters || ''}`,
                method: 'GET'
            }),
            providesTags: (result = [], error, arg) => [{type: 'LibraryPackageList', id:`filters:${arg}`}],
        }),
        addBookToFavorite: build.mutation({
            query: (payload) => ({
                url: `/library/add-to-favorite`,
                method: 'POST',
                body: { ...payload }
            }),
            invalidatesTags:['LibraryList']
        }),
        deleteBookFromFavorite: build.mutation({
            query: (payload) => ({
                url: `/library/delete-from-favorite`,
                method: 'DELETE',
                body: { ...payload }
            }),
            invalidatesTags:['LibraryList']
        }),
        getCollectionList: build.query({
            query: () => ({
                url: `/library/collection-list`,
                method: 'GET'
            })
        }),
        getPackagePriceList: build.mutation({
            query: (filters) => ({
                url: `/library/package-price-list${filters || ''}`,
                method: 'GET'
            })
        })
    })
});

export const {
    useLazyGetListQuery,
    useGetPublisherListQuery,
    useGetPackageListQuery,
    useAddBookToFavoriteMutation,
    useDeleteBookFromFavoriteMutation,
    useGetCollectionListQuery,
    useLazyGetPackageListQuery,
    useGetPackagePriceListMutation,
    useLazyGetCheckSubscriptionAccessQuery,
} = libraryApi;
